import { toast } from "react-toastify";
import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";

export const uploadSingleFileImage = async (data, onSuccess) => {
  console.log("data", data);
  try {
    let response = await _axios.post(END_POINTS.UPLOAD_SINGLE_FILE, data);
    console.log("upload single image", response);
    if (onSuccess) onSuccess(response?.data);
    return {
      success: true,
      data: response?.data?.data?.url,
    };
  } catch (e) {
    console.log("error====>", e);
    return {
      success: false,
      data: e?.response?.data?.errors[0],
    };
  }
};

export const uploadMultipleFileImage = async (data, onSuccess) => {
  console.log("data", data);
  try {
    let response = await _axios.post(END_POINTS.UPLOAD_MULTIPLE_FILE, data);
    console.log("upload MULTIPLE image", response);
    if (onSuccess) onSuccess(response?.data);
    return {
      success: true,
      data: response?.data?.data,
    };
  } catch (e) {
    console.log("error====>", e);
  }
};

export const uploadSingleFileVideo = async (data, onSuccess) => {
  console.log("data", data);
  try {
    let response = await _axios.post(END_POINTS.UPLOAD_SINGLE_VIDEO, data);
    console.log("upload single image", response);
    if (onSuccess) onSuccess(response?.data);
    return {
      success: true,
      data: response?.data?.data?.url,
    };
  } catch (e) {
    console.log("error====>", e);
    toast.error("Video cannot be uploaded , either its too large or malformed ")
    throw e
  }
};
